import { useQuery } from "@tanstack/react-query";
import { useLocalLogic } from "~/context/LocalLogicProvider";
import {
  demographicsResponse,
  demographicsKeys,
} from "~/features/demographics";
import { type Location } from "~/types/sdks";

export function useDemographicsData({ lat, lng, geographyId }: Location) {
  const { client } = useLocalLogic();

  const options: demographicsResponse = {};

  if (geographyId) {
    options.geographyId = geographyId;
  } else {
    options.lat = lat || NaN;
    options.lng = lng || NaN;
  }

  return useQuery({
    queryKey: demographicsKeys.list(options),
    queryFn: async () =>
      client.getDemographics(options as unknown as demographicsResponse),
    enabled: !!geographyId || (!!lat && !!lng),
  });
}
